module.exports = __webpack_public_path__ + "static/media/Chiller_Plant-1.fb040aa8.png";